import * as React from "react";
import Increment from "../functions/Increment.js";
import AddIcon from "@mui/icons-material/Add";
import SchoolIcon from "@mui/icons-material/School";

function LaborStatistics({ isMobile = false }) {
  const experience = Increment({ limite: 5, intervalo: 500 });
  const jobs = Increment({ limite: 6, intervalo: 500 });

  return (
    <>
      {!isMobile ? (
        <div className="grid grid-cols-3 gap-4">
          <div className="flex mt-2">
            <AddIcon
              className="text-amarillo mt-1 ml-2"
              sx={{ fontSize: 20 }}
            />
            <span className="text-amarillo text-xl font-bold">
              {experience}
            </span>
            <span className="text-white text-sm mt-1 ml-2">
              años de experiencia
            </span>
          </div>

          <div className="flex mt-2">
            <span className="text-amarillo text-xl font-bold">{jobs}</span>
            <span className="text-white text-sm mt-1 ml-2">
              trabajos desempeñados
            </span>
          </div>

          <div className="flex mt-3">
            <SchoolIcon className="text-amarillo ml-2" sx={{ fontSize: 20 }} />
            <span className="text-white text-sm ml-2">
              Certificación en el idioma Inglés
            </span>
          </div>
        </div>
      ) : (

        <div className="mt-3">
          <div className="flex">
            <AddIcon
              className="text-amarillo mt-1 ml-2"
              sx={{ fontSize: 26 }}
            />
            <span className="text-amarillo text-2xl font-bold">
              {experience}
            </span>
            <span className="text-white text-md mt-2 ml-2">
              Años de experiencia
            </span>
          </div>

          <div className="flex mt-2">
            <span className="text-amarillo text-2xl font-bold ml-9">{jobs}</span>
            <span className="text-white text-md mt-1 ml-2">
              Trabajos desempeñados
            </span>
          </div>

          <div className="flex mt-3">
            <SchoolIcon className="text-amarillo ml-7" sx={{ fontSize: 24 }} />
            <span className="text-white text-md ml-2">
              Certificación en Inglés
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default LaborStatistics;
